module.exports = __webpack_public_path__ + "img/rectangle.0b6f6b6a.svg";